export const UserIndexSceneTranslation = {
  fi: {
    UserIndexScene: {
      title: 'Käyttäjät',
    },
  },
};
